import { Typography, useTheme, Box } from '@mui/material';
import {
  type GridRowData,
  type GridColumns,
  type GridValidRowModel,
} from '@mui/x-data-grid';
import { CustomDataGrid } from 'components';
import { colorTheme } from 'theme';
import { useEffect, useState } from 'react';
import { getAllUserWithdrawalRequests } from 'service';
import { useParams } from 'react-router-dom';
import { strings } from 'i18n/Strings';
import { commonConstantTexts } from 'constants/constantText';
import { useSelector } from 'react-redux';

interface PlanRequests {
  requests: Request[];
}

interface Request {
  requestId: string;
  status: string;
  user: User;
}

interface User {
  userId: string;
  firstName: string;
  lastName: string;
}

export const dateFormatter = (date: Date): string =>
  new Date(date).toLocaleDateString('en-GB');

const UserWithdrawalRequests = (): JSX.Element => {
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);
  const { id } = useParams();
  const [planData, setPlanData] = useState<Request[]>([]);
  const [pageCount, setPageCount] = useState(null);
  const pageInfo = useSelector(
    (state) => state?.pagination?.withdrawalRequests,
  );
  const getUserWithdrawalRequests = async (): Promise<void> => {
    try {
      const withdrawalRequests = (await getAllUserWithdrawalRequests(
        id,
        Number(pageInfo?.page) + 1,
        pageInfo?.pageSize,
      )) as PlanRequests;
      setPlanData(withdrawalRequests?.rows);
      setPageCount(withdrawalRequests?.count);
    } catch (error) {}
  };

  useEffect(() => {
    void getUserWithdrawalRequests();
  }, [pageInfo?.page, pageInfo?.pageSize]);
  const columns: GridColumns<GridValidRowModel> = [
    {
      field: 'id',
      flex: 1,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.requestId}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row.requestId}
        </Typography>
      ),
    },
    {
      field: 'date',
      flex: 1,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.dateColumn}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {dateFormatter(row.createdAt)}
        </Typography>
      ),
    },
    {
      field: 'status',
      flex: 1,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.statusColumn}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row.status}
        </Typography>
      ),
    },
  ];

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <CustomDataGrid
          columns={columns}
          rows={planData as GridRowData[]}
          getRowId={(row: GridRowData) => `${String(row.requestId)}`}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? commonConstantTexts.evenText
              : commonConstantTexts.oddText
          }
          currentPage={commonConstantTexts.withdrawalRequestsPage}
          pageCount={pageCount}
        />
      </Box>
    </>
  );
};

export default UserWithdrawalRequests;
